import { UpperCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { environment } from '../environments/environment';
import { RouterModule, RouterOutlet } from '@angular/router';
import { NxHeaderModule } from '@allianz/ng-aquila/header';
import { NxFooterModule } from '@allianz/ng-aquila/footer';
import { TranslocoPipe } from '@jsverse/transloco';
import { AccessibilityModule } from './components/accessibility/accessibility.module';
import { DropdownLanguageComponent } from './components/dropdown-language/dropdown-language.component';


@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NxHeaderModule,
    NxFooterModule,
    TranslocoPipe,
    UpperCasePipe,
    RouterModule,
    AccessibilityModule,
    DropdownLanguageComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  readonly currentYear = new Date().getFullYear();
  currentEnvironment: string = environment.environment;
  isNonProdEnvironment = ['local', 'dev02', 'uatr', 'uatm', 'proddre'].includes(this.currentEnvironment);
}
